<!--  -->
<template>
  <div class="head">
    <img src="../assets/top.gif" />
    <div class="head-left">
      <div class="cname">木棉树LNG接收站可视化系统</div>
      <div class="ename">Visualization system of kapok tree LNG terminal</div>
    </div>
    <div class="head-right">
      <div class="date">
        <div style="margin-right:10px">{{date}}</div>
        <div style="margin-right:25px">{{dateTime}}</div>
        <div>{{wendu}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { weather } from "../request/baseapi";
export default {
  data() {
    return {
      date: "",
      dateTime: "",
      timer: "",
      wendu: "",
      hh: new Date().getHours(),
      mf:
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes(),
      ss:
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds()
    };
  },

  mounted() {
    this.timer = setInterval(() => {
      this.hh = new Date().getHours();
      (this.mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes()),
        (this.ss =
          new Date().getSeconds() < 10
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds());
      this.dateTime = this.hh + ":" + this.mf + ":" + this.ss;
    }, 1000);
  },

  created() {
    this.initdata();
  },

  components: {},

  computed: {},

  methods: {
    initdata() {
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      this.date = yy + "-" + mm + "-" + dd;
      this.dateTime = this.hh + ":" + this.mf + ":" + this.ss;
      weather("重庆").then(res => {
        this.wendu = res.data.wendu;
        if(res.data.wendu >= 25){
          this.wendu = "晴天"
        }else{
          this.wendu = "阴天"
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.head {
  position: absolute;

  height: 130px;
  left: 0;
  width: 100%;
  // margin-left: 2.5%;
  display: flex;
  z-index: 1000;
  background: url(../assets/headbg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  img {
    position: absolute;
    top: -8px;
    left: 3.7%;
    width: 80%;
  }
  .head-left {
    margin-left: 69px;
    margin-top: 10px;
    width: 32%;
    height: 40px;
    color: #fff;
    text-align: left;
    position: relative;
    bottom: 13px;
    margin-right: 1%;
    .cname {
      font-size: 40.5px;
      letter-spacing: 5px;
    }
    .ename {
      position: relative;
      bottom: 12px;
      font-family: sy;
      font-size: 16px;
      letter-spacing: 2px;
      text-transform: uppercase;
    }
  }
  .head-right {
    width: 61%;
    height: 39px;
    background: url("../assets/top.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 5px;


    .date {
      display: flex;
      position: absolute;
      right: 114px;
      top: 8px;
      width: auto;
      font-size: 12px;
      margin-top: 10px;
      color: #fff;
    }
  }
}
</style>